<template>
  <div>
    <textarea :disabled="disabled" class="form-control rounded-4" @input="$emit('input', $event.target.value)">{{ value }}</textarea>
    <button :disabled="disabled" class="btn btn-primary" @click="$emit('answered')">submit</button>
  </div>
</template>

<script>
  export default {
    name: "z-text",
    props: {
      value: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>
  textarea {
    resize: none;
    height: 150px;
  }

  button {
    margin: 5px;
    padding: 10px 40px;
    border-radius: 5px;
  }

</style>